/* eslint-disable vue/no-use-v-if-with-v-for */
<template>
  <ul>
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in items"
      :key="item.header || item.title"
      :item="item"
    />

  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref } from '@vue/composition-api'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      abiltys: [
        {
          resource: 'Dashboard',
          action: 'read',
        },
        {
          action: 'read',
          resource: 'Auth',
        },
        {
          action: 'read',
          resource: 'Users',
        },
        {
          resource: 'Roles',
          action: 'create',
        },
        {
          resource: 'Roles',
          action: 'update',
        },
        {
          resource: 'Roles',
          action: 'delete',
        },
        // {
        //   resource: 'Orders',
        //   action: 'read',
        // },
        // {
        //   action: 'manage',
        //   subject: 'all',
        // },
      ],
    }
  },
  created() {
    // this.items.forEach(item => {
    //   if (item.hasOwnProperty('children')) {
    //     item.children.forEach(child => {
    //       const matchActions = this.abiltys.filter(c => c.resource === child.resource).map(c => c.action)
    //       console.log('matchActions ', this.abiltys.filter(c => c.resource === child.resource).map(c => c.action))
    //       console.log('has read ', matchActions.includes('read'))

    //       if (matchActions.indexOf('read') > 0) child.isActive = true
    //       else child.isActive = false
    //     })
    //   } else item.isActive = true
    // })
    // console.log('all items', this.items)
    // //  this.abiltys.forEach(item => {
    //    this.items.forEach(())
    // })
  },
  methods: {
    hasPrivilege() {

      // .forEach(ablilty => {
      //   if (item.hasOwnProperty('children')) {
      //     ablilty.children.forEach(child => {
      //       if (item.resource === child.resource && item.action === child.action) { result = true }
      //     })
      //   } else { result = true }
      // })
    },
  },
  setup() {
    provide('openGroups', ref([]))

    return {
      resolveNavItemComponent,
    }
  },
}
</script>
